/*
  SW: Kaydırıcılardaki sayısal sayacı ("1 / 8") ince bir ilerleme çubuğuna çevirir.

  Tema JS'i (global.js -> SliderComponent) .slider-counter--current ve
  .slider-counter--total elemanlarına yazmaya devam eder; bu elemanlar DOM'da
  kalır, sadece görsel olarak gizlenir (ekran okuyucu için erişilebilir kalır).
  Böylece hiçbir bölümün Liquid'ine dokunmadan tüm kaydırıcılar aynı anda düzelir.
*/
(function () {
  var SELECTOR = '.slider-buttons .slider-counter';

  function enhance(counter) {
    if (counter.dataset.swProgress === 'on') return;
    if (!counter.querySelector('.slider-counter--current')) return;

    var component = counter.closest('slider-component, slideshow-component');
    if (!component) return;
    var slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    counter.dataset.swProgress = 'on';
    counter.classList.add('slider-counter--progress');

    var track = document.createElement('span');
    track.className = 'slider-progress';
    track.setAttribute('aria-hidden', 'true');
    var bar = document.createElement('span');
    bar.className = 'slider-progress__bar';
    track.appendChild(bar);
    counter.appendChild(track);

    var raf = null;
    function paint() {
      raf = null;
      var scrollable = slider.scrollWidth - slider.clientWidth;
      var portion = slider.scrollWidth > 0 ? slider.clientWidth / slider.scrollWidth : 1;
      var width = Math.max(0.2, Math.min(1, portion));
      var ratio = scrollable > 5 ? slider.scrollLeft / scrollable : 0;

      // Kaydırılacak bir şey yoksa çubuğu tamamen gizle.
      counter.classList.toggle('slider-counter--progress-idle', scrollable <= 5);

      bar.style.width = (width * 100).toFixed(3) + '%';
      bar.style.transform = 'translateX(' + (ratio * (100 / width - 100)).toFixed(3) + '%)';
    }

    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(paint);
    }

    slider.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(schedule).observe(slider);
    }

    paint();
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // Bölüm yeniden yüklendiğinde (tema editörü, filtre, sonsuz kaydırma) tekrar tara.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
  window.addEventListener('load', function () {
    scan();
  });
})();
